import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_SEO_SETTINGS = `${URL_RETAILER_SCOPED}/seo-settings`
const URL_SEO_SETTINGS_ROBOTS_TXT = `${URL_SEO_SETTINGS}/robots-txt`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'seo-settings'> | DashRouteType<'seo-settings-robots-txt'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'seo-settings': URL_SEO_SETTINGS,
  'seo-settings-robots-txt': URL_SEO_SETTINGS_ROBOTS_TXT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
